var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu",
    width: 29.85,
    height: 31.85,
    viewBox: "0 0 35.85 35.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12247",
    "data-name": "Path 12247",
    d: "M12.183,16.8H4.621A4.626,4.626,0,0,1,0,12.183V4.621A4.626,4.626,0,0,1,4.621,0h7.562A4.626,4.626,0,0,1,16.8,4.621v7.562A4.626,4.626,0,0,1,12.183,16.8ZM4.621,2.241A2.383,2.383,0,0,0,2.241,4.621v7.562a2.383,2.383,0,0,0,2.381,2.381h7.562a2.383,2.383,0,0,0,2.381-2.381V4.621a2.383,2.383,0,0,0-2.381-2.381Z",
    fill: "#4c85f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12248",
    "data-name": "Path 12248",
    d: "M284.183,16.8h-7.562A4.626,4.626,0,0,1,272,12.183V4.621A4.626,4.626,0,0,1,276.621,0h7.562A4.626,4.626,0,0,1,288.8,4.621v7.562A4.626,4.626,0,0,1,284.183,16.8ZM276.621,2.241a2.383,2.383,0,0,0-2.381,2.381v7.562a2.383,2.383,0,0,0,2.381,2.381h7.562a2.383,2.383,0,0,0,2.381-2.381V4.621a2.383,2.383,0,0,0-2.381-2.381Z",
    transform: "translate(-252.955)",
    fill: "#4c85f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12249",
    "data-name": "Path 12249",
    d: "M280.4,288.8a8.4,8.4,0,1,1,8.4-8.4A8.412,8.412,0,0,1,280.4,288.8Zm0-14.564a6.162,6.162,0,1,0,6.162,6.162A6.169,6.169,0,0,0,280.4,274.241Z",
    transform: "translate(-252.955 -252.955)",
    fill: "#4c85f7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12250",
    "data-name": "Path 12250",
    d: "M12.183,288.8H4.621A4.626,4.626,0,0,1,0,284.183v-7.562A4.626,4.626,0,0,1,4.621,272h7.562a4.626,4.626,0,0,1,4.621,4.621v7.562A4.626,4.626,0,0,1,12.183,288.8ZM4.621,274.241a2.383,2.383,0,0,0-2.381,2.381v7.562a2.383,2.383,0,0,0,2.381,2.381h7.562a2.383,2.383,0,0,0,2.381-2.381v-7.562a2.383,2.383,0,0,0-2.381-2.381Z",
    transform: "translate(0 -252.955)",
    fill: "#4c85f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/menu1.859d8e749fc1e1d864c207f524dccf98.svg";
export { ForwardRef as ReactComponent };